import { render, staticRenderFns } from "./VDataTableWordClouds.vue?vue&type=template&id=3ad13962&scoped=true"
import script from "./VDataTableWordClouds.vue?vue&type=script&lang=js"
export * from "./VDataTableWordClouds.vue?vue&type=script&lang=js"
import style0 from "./VDataTableWordClouds.vue?vue&type=style&index=0&id=3ad13962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad13962",
  null
  
)

export default component.exports